import ModuleWrapper from 'shared-lib/containers/Module';

const Blacklist  = () => import(/* webpackChunkName: "blacklist" */ '@/views/settings/Blacklist');
const meta = (data = {}) => ({
    permissionsModuleName: 'blacklist',
    auth: true,
    ...data,
});

export default [{
    path: 'blacklist',
    component: ModuleWrapper,
    meta: meta({
        title: 'Blacklist',
        permission: 'list',
    }),
    children: [
        {
            path: '',
            name: 'Blacklist',
            component: Blacklist,
            meta: meta({
                permission: 'list',
            }),
        },
    ],
}];
